module.exports = "/_next/static/images/tennisWhiteIcon@3x-65826f7146de7d5603c95a103f8b791b.png";